import { loadingImageList } from '@shared/hooks/useShowLoadingAnimation';

let loadingImagetempList = [...loadingImageList];
export const getRandomImage = () => {
  const index = Math.floor(Math.random() * (loadingImagetempList.length - 1));
  const [image] = loadingImagetempList.splice(index, 1);
  if (loadingImagetempList.length === 0) loadingImagetempList = [...loadingImageList];
  return image;
};
